document.addEventListener('DOMContentLoaded', function() {
    const statusItems = document.querySelectorAll('.status-item');
    
    async function processApplication() {
        try {
            const rawCustomerData = JSON.parse(sessionStorage.getItem('customerData') || '{}');
            const rawProducts = JSON.parse(localStorage.getItem('selectedProducts') || '[]');
            const signatureData = sessionStorage.getItem('signature');

            if (!rawCustomerData || !rawProducts || !signatureData) {
                throw new Error('Erforderliche Daten fehlen');
            }

            updateProcessStep(0);
            const res = await fetch("https://caredirekt24--development.gadget.app/create-customer", {
              method: "POST",
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(rawCustomerData),
            });
            const customer = await res.json();
            if ( !customer.success ){
              throw new Error(customer.errors);
            }
            updateProcessStep(1);

            const { customerId } = customer;
            // Bestellung erstellen
            const orderRes = await fetch("https://caredirekt24--development.gadget.app/draft-order", {
              method: "POST",
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                customerId,
                products: rawProducts,
                deliveryAddress: {
                  firstName: rawCustomerData.deliveryFirstName,
                  lastName: rawCustomerData.deliveryLastName,
                  street: rawCustomerData.deliveryStreet,
                  number: rawCustomerData.deliveryNumber,
                  city: rawCustomerData.deliveryCity,
                  zip: rawCustomerData.deliveryZip
                }
              }),
            });

            const order = await orderRes.json();
            if ( !order.success ){
              throw new Error(order.errors);
            }
            updateProcessStep(2);

            // Aufräumen
            localStorage.removeItem('selectedProducts');
            sessionStorage.removeItem('customerData');
            sessionStorage.removeItem('signature');

            // Weiterleitung
            window.location.href = '/pages/pflegebox-danke';

        } catch (error) {
            console.error('Fehler:', error);
            showError(error);
        }
    }

    function updateProcessStep(step) {
        statusItems.forEach((item, index) => {
            if (index < step) {
                item.classList.add('done');
                item.classList.remove('active');
            } else if (index === step) {
                item.classList.add('active');
                item.classList.remove('done');
            } else {
                item.classList.remove('done', 'active');
            }
        });
    }

    function showError(error) {
        document.querySelector('.process-steps').style.display = 'none';
        document.getElementById('error-message').style.display = 'block';
        document.getElementById('error-detail').innerHTML = error.message;
    }

    processApplication();
});